import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import { PostHogErrorBoundary, PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";
const root = ReactDOM.createRoot(document.getElementById("root"));

if (!process.env.REACT_APP_POSTHOG_KEY || !process.env.REACT_APP_POSTHOG_HOST) {
   throw new Error("REACT_APP_POSTHOG_KEY or REACT_APP_POSTHOG_HOST is not set");
}

const Layout = ({ children }) => {
   return (
      <PostHogProvider
         apiKey={process.env.REACT_APP_POSTHOG_KEY}
         options={{
            api_host: process.env.REACT_APP_POSTHOG_HOST,
            defaults: "2025-05-24",
            capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
            debug: process.env.REACT_APP_ENVIRONMENT !== "prod",
            capture_exceptions: {
               capture_console_errors: true,
               capture_unhandled_errors: true,
               capture_unhandled_rejections: true,
            },
            capture_performance: true,
            capture_pageleave: true,
            error_tracking: true,
         }}
      >
         <PostHogErrorBoundary>{children}</PostHogErrorBoundary>
      </PostHogProvider>
   );
};

root.render(
   <React.StrictMode>
      <Layout>
         <App />
      </Layout>
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
